/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BookRouteImport } from './routes/book'
import { Route as BookingRouteImport } from './routes/booking'
import { Route as CarDetailingGeelongRouteImport } from './routes/car-detailing-geelong'
import { Route as CeramicCoatingGeelongRouteImport } from './routes/ceramic-coating-geelong'
import { Route as CeramicProtectionRouteImport } from './routes/ceramic-protection'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DetailingRouteImport } from './routes/detailing'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as InteriorRouteImport } from './routes/interior'
import { Route as InteriorDetailingRouteImport } from './routes/interior-detailing'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as PaintCorrectionRouteImport } from './routes/paint-correction'
import { Route as AdminBookingsRouteImport } from './routes/admin_.bookings'
import { Route as AdminCustomersRouteImport } from './routes/admin_.customers'
import { Route as AdminQuotesRouteImport } from './routes/admin_.quotes'
import { Route as AdminServicesRouteImport } from './routes/admin_.services'
import { Route as BookingPaymentCancelledRouteImport } from './routes/booking.payment-cancelled'
import { Route as BookingPaymentSuccessRouteImport } from './routes/booking.payment-success'
import { Route as BookingScheduleRouteImport } from './routes/booking.schedule'
import { Route as BookingSummaryRouteImport } from './routes/booking.summary'
import { Route as DetailingQuoteRouteImport } from './routes/detailing_.quote'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BookRoute = BookRouteImport.update({
  id: '/book',
  path: '/book',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingRoute = BookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => rootRouteImport,
} as any)
const CarDetailingGeelongRoute = CarDetailingGeelongRouteImport.update({
  id: '/car-detailing-geelong',
  path: '/car-detailing-geelong',
  getParentRoute: () => rootRouteImport,
} as any)
const CeramicCoatingGeelongRoute = CeramicCoatingGeelongRouteImport.update({
  id: '/ceramic-coating-geelong',
  path: '/ceramic-coating-geelong',
  getParentRoute: () => rootRouteImport,
} as any)
const CeramicProtectionRoute = CeramicProtectionRouteImport.update({
  id: '/ceramic-protection',
  path: '/ceramic-protection',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const DetailingRoute = DetailingRouteImport.update({
  id: '/detailing',
  path: '/detailing',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const InteriorRoute = InteriorRouteImport.update({
  id: '/interior',
  path: '/interior',
  getParentRoute: () => rootRouteImport,
} as any)
const InteriorDetailingRoute = InteriorDetailingRouteImport.update({
  id: '/interior-detailing',
  path: '/interior-detailing',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesRoute = PackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => rootRouteImport,
} as any)
const PaintCorrectionRoute = PaintCorrectionRouteImport.update({
  id: '/paint-correction',
  path: '/paint-correction',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBookingsRoute = AdminBookingsRouteImport.update({
  id: '/admin_/bookings',
  path: '/admin/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCustomersRoute = AdminCustomersRouteImport.update({
  id: '/admin_/customers',
  path: '/admin/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminQuotesRoute = AdminQuotesRouteImport.update({
  id: '/admin_/quotes',
  path: '/admin/quotes',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminServicesRoute = AdminServicesRouteImport.update({
  id: '/admin_/services',
  path: '/admin/services',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingPaymentCancelledRoute = BookingPaymentCancelledRouteImport.update({
  id: '/payment-cancelled',
  path: '/payment-cancelled',
  getParentRoute: () => BookingRoute,
} as any)
const BookingPaymentSuccessRoute = BookingPaymentSuccessRouteImport.update({
  id: '/payment-success',
  path: '/payment-success',
  getParentRoute: () => BookingRoute,
} as any)
const BookingScheduleRoute = BookingScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => BookingRoute,
} as any)
const BookingSummaryRoute = BookingSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => BookingRoute,
} as any)
const DetailingQuoteRoute = DetailingQuoteRouteImport.update({
  id: '/detailing_/quote',
  path: '/detailing/quote',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/book': typeof BookRoute
  '/booking': typeof BookingRouteWithChildren
  '/car-detailing-geelong': typeof CarDetailingGeelongRoute
  '/ceramic-coating-geelong': typeof CeramicCoatingGeelongRoute
  '/ceramic-protection': typeof CeramicProtectionRoute
  '/contact': typeof ContactRoute
  '/detailing': typeof DetailingRoute
  '/gallery': typeof GalleryRoute
  '/interior': typeof InteriorRoute
  '/interior-detailing': typeof InteriorDetailingRoute
  '/packages': typeof PackagesRoute
  '/paint-correction': typeof PaintCorrectionRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/quotes': typeof AdminQuotesRoute
  '/admin/services': typeof AdminServicesRoute
  '/booking/payment-cancelled': typeof BookingPaymentCancelledRoute
  '/booking/payment-success': typeof BookingPaymentSuccessRoute
  '/booking/schedule': typeof BookingScheduleRoute
  '/booking/summary': typeof BookingSummaryRoute
  '/detailing/quote': typeof DetailingQuoteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/book': typeof BookRoute
  '/booking': typeof BookingRouteWithChildren
  '/car-detailing-geelong': typeof CarDetailingGeelongRoute
  '/ceramic-coating-geelong': typeof CeramicCoatingGeelongRoute
  '/ceramic-protection': typeof CeramicProtectionRoute
  '/contact': typeof ContactRoute
  '/detailing': typeof DetailingRoute
  '/gallery': typeof GalleryRoute
  '/interior': typeof InteriorRoute
  '/interior-detailing': typeof InteriorDetailingRoute
  '/packages': typeof PackagesRoute
  '/paint-correction': typeof PaintCorrectionRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/quotes': typeof AdminQuotesRoute
  '/admin/services': typeof AdminServicesRoute
  '/booking/payment-cancelled': typeof BookingPaymentCancelledRoute
  '/booking/payment-success': typeof BookingPaymentSuccessRoute
  '/booking/schedule': typeof BookingScheduleRoute
  '/booking/summary': typeof BookingSummaryRoute
  '/detailing/quote': typeof DetailingQuoteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/book': typeof BookRoute
  '/booking': typeof BookingRouteWithChildren
  '/car-detailing-geelong': typeof CarDetailingGeelongRoute
  '/ceramic-coating-geelong': typeof CeramicCoatingGeelongRoute
  '/ceramic-protection': typeof CeramicProtectionRoute
  '/contact': typeof ContactRoute
  '/detailing': typeof DetailingRoute
  '/gallery': typeof GalleryRoute
  '/interior': typeof InteriorRoute
  '/interior-detailing': typeof InteriorDetailingRoute
  '/packages': typeof PackagesRoute
  '/paint-correction': typeof PaintCorrectionRoute
  '/admin_/bookings': typeof AdminBookingsRoute
  '/admin_/customers': typeof AdminCustomersRoute
  '/admin_/quotes': typeof AdminQuotesRoute
  '/admin_/services': typeof AdminServicesRoute
  '/booking/payment-cancelled': typeof BookingPaymentCancelledRoute
  '/booking/payment-success': typeof BookingPaymentSuccessRoute
  '/booking/schedule': typeof BookingScheduleRoute
  '/booking/summary': typeof BookingSummaryRoute
  '/detailing_/quote': typeof DetailingQuoteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/book'
    | '/booking'
    | '/car-detailing-geelong'
    | '/ceramic-coating-geelong'
    | '/ceramic-protection'
    | '/contact'
    | '/detailing'
    | '/gallery'
    | '/interior'
    | '/interior-detailing'
    | '/packages'
    | '/paint-correction'
    | '/admin/bookings'
    | '/admin/customers'
    | '/admin/quotes'
    | '/admin/services'
    | '/booking/payment-cancelled'
    | '/booking/payment-success'
    | '/booking/schedule'
    | '/booking/summary'
    | '/detailing/quote'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/admin'
    | '/book'
    | '/booking'
    | '/car-detailing-geelong'
    | '/ceramic-coating-geelong'
    | '/ceramic-protection'
    | '/contact'
    | '/detailing'
    | '/gallery'
    | '/interior'
    | '/interior-detailing'
    | '/packages'
    | '/paint-correction'
    | '/admin/bookings'
    | '/admin/customers'
    | '/admin/quotes'
    | '/admin/services'
    | '/booking/payment-cancelled'
    | '/booking/payment-success'
    | '/booking/schedule'
    | '/booking/summary'
    | '/detailing/quote'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/admin'
    | '/book'
    | '/booking'
    | '/car-detailing-geelong'
    | '/ceramic-coating-geelong'
    | '/ceramic-protection'
    | '/contact'
    | '/detailing'
    | '/gallery'
    | '/interior'
    | '/interior-detailing'
    | '/packages'
    | '/paint-correction'
    | '/admin_/bookings'
    | '/admin_/customers'
    | '/admin_/quotes'
    | '/admin_/services'
    | '/booking/payment-cancelled'
    | '/booking/payment-success'
    | '/booking/schedule'
    | '/booking/summary'
    | '/detailing_/quote'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRoute
  BookRoute: typeof BookRoute
  BookingRoute: typeof BookingRouteWithChildren
  CarDetailingGeelongRoute: typeof CarDetailingGeelongRoute
  CeramicCoatingGeelongRoute: typeof CeramicCoatingGeelongRoute
  CeramicProtectionRoute: typeof CeramicProtectionRoute
  ContactRoute: typeof ContactRoute
  DetailingRoute: typeof DetailingRoute
  GalleryRoute: typeof GalleryRoute
  InteriorRoute: typeof InteriorRoute
  InteriorDetailingRoute: typeof InteriorDetailingRoute
  PackagesRoute: typeof PackagesRoute
  PaintCorrectionRoute: typeof PaintCorrectionRoute
  AdminBookingsRoute: typeof AdminBookingsRoute
  AdminCustomersRoute: typeof AdminCustomersRoute
  AdminQuotesRoute: typeof AdminQuotesRoute
  AdminServicesRoute: typeof AdminServicesRoute
  DetailingQuoteRoute: typeof DetailingQuoteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book': {
      id: '/book'
      path: '/book'
      fullPath: '/book'
      preLoaderRoute: typeof BookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking': {
      id: '/booking'
      path: '/booking'
      fullPath: '/booking'
      preLoaderRoute: typeof BookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/car-detailing-geelong': {
      id: '/car-detailing-geelong'
      path: '/car-detailing-geelong'
      fullPath: '/car-detailing-geelong'
      preLoaderRoute: typeof CarDetailingGeelongRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ceramic-coating-geelong': {
      id: '/ceramic-coating-geelong'
      path: '/ceramic-coating-geelong'
      fullPath: '/ceramic-coating-geelong'
      preLoaderRoute: typeof CeramicCoatingGeelongRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ceramic-protection': {
      id: '/ceramic-protection'
      path: '/ceramic-protection'
      fullPath: '/ceramic-protection'
      preLoaderRoute: typeof CeramicProtectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/detailing': {
      id: '/detailing'
      path: '/detailing'
      fullPath: '/detailing'
      preLoaderRoute: typeof DetailingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interior': {
      id: '/interior'
      path: '/interior'
      fullPath: '/interior'
      preLoaderRoute: typeof InteriorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interior-detailing': {
      id: '/interior-detailing'
      path: '/interior-detailing'
      fullPath: '/interior-detailing'
      preLoaderRoute: typeof InteriorDetailingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages': {
      id: '/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof PackagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/paint-correction': {
      id: '/paint-correction'
      path: '/paint-correction'
      fullPath: '/paint-correction'
      preLoaderRoute: typeof PaintCorrectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/bookings': {
      id: '/admin_/bookings'
      path: '/admin/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AdminBookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/customers': {
      id: '/admin_/customers'
      path: '/admin/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/quotes': {
      id: '/admin_/quotes'
      path: '/admin/quotes'
      fullPath: '/admin/quotes'
      preLoaderRoute: typeof AdminQuotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/services': {
      id: '/admin_/services'
      path: '/admin/services'
      fullPath: '/admin/services'
      preLoaderRoute: typeof AdminServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/payment-cancelled': {
      id: '/booking/payment-cancelled'
      path: '/payment-cancelled'
      fullPath: '/booking/payment-cancelled'
      preLoaderRoute: typeof BookingPaymentCancelledRouteImport
      parentRoute: typeof BookingRoute
    }
    '/booking/payment-success': {
      id: '/booking/payment-success'
      path: '/payment-success'
      fullPath: '/booking/payment-success'
      preLoaderRoute: typeof BookingPaymentSuccessRouteImport
      parentRoute: typeof BookingRoute
    }
    '/booking/schedule': {
      id: '/booking/schedule'
      path: '/schedule'
      fullPath: '/booking/schedule'
      preLoaderRoute: typeof BookingScheduleRouteImport
      parentRoute: typeof BookingRoute
    }
    '/booking/summary': {
      id: '/booking/summary'
      path: '/summary'
      fullPath: '/booking/summary'
      preLoaderRoute: typeof BookingSummaryRouteImport
      parentRoute: typeof BookingRoute
    }
    '/detailing_/quote': {
      id: '/detailing_/quote'
      path: '/detailing/quote'
      fullPath: '/detailing/quote'
      preLoaderRoute: typeof DetailingQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface BookingRouteChildren {
  BookingPaymentCancelledRoute: typeof BookingPaymentCancelledRoute
  BookingPaymentSuccessRoute: typeof BookingPaymentSuccessRoute
  BookingScheduleRoute: typeof BookingScheduleRoute
  BookingSummaryRoute: typeof BookingSummaryRoute
}

const BookingRouteChildren: BookingRouteChildren = {
  BookingPaymentCancelledRoute: BookingPaymentCancelledRoute,
  BookingPaymentSuccessRoute: BookingPaymentSuccessRoute,
  BookingScheduleRoute: BookingScheduleRoute,
  BookingSummaryRoute: BookingSummaryRoute,
}

const BookingRouteWithChildren =
  BookingRoute._addFileChildren(BookingRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRoute,
  BookRoute: BookRoute,
  BookingRoute: BookingRouteWithChildren,
  CarDetailingGeelongRoute: CarDetailingGeelongRoute,
  CeramicCoatingGeelongRoute: CeramicCoatingGeelongRoute,
  CeramicProtectionRoute: CeramicProtectionRoute,
  ContactRoute: ContactRoute,
  DetailingRoute: DetailingRoute,
  GalleryRoute: GalleryRoute,
  InteriorRoute: InteriorRoute,
  InteriorDetailingRoute: InteriorDetailingRoute,
  PackagesRoute: PackagesRoute,
  PaintCorrectionRoute: PaintCorrectionRoute,
  AdminBookingsRoute: AdminBookingsRoute,
  AdminCustomersRoute: AdminCustomersRoute,
  AdminQuotesRoute: AdminQuotesRoute,
  AdminServicesRoute: AdminServicesRoute,
  DetailingQuoteRoute: DetailingQuoteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
